import * as THREE from 'three'
import Experience from '../Experience'

export default class South {
  constructor() {
    //setup
    this.experience = new Experience()
    this.scene = experience.scene
    this.resources = experience.resources
    this.time = experience.time
    this.debug = experience.debug
    //Options
    this.resource = this.resources.items.south

    //Methods
    this.setMaterial()
    this.setModel()
    this.hidePart()
  }
  setMaterial() {
    //south
    this.southTexture = this.resources.items.southTexture
    this.southTexture.flipY = false
    this.southTexture.encoding = THREE.sRGBEncoding
    this.southMaterial = new THREE.MeshBasicMaterial({ map: this.southTexture })

    //logo
    this.logoTexture = this.resources.items.logoField
    this.logoTexture.flipY = false
    this.logoTexture.encoding = THREE.sRGBEncoding
    this.logoMaterial = new THREE.MeshBasicMaterial({ map: this.logoTexture, transparent: true })
  }
  setModel() {
    this.model = this.resource.scene
    //logos
    const logoLeft = this.model.children.find(child => child.name === 'logo003')
    logoLeft.material = this.logoMaterial
    const logoRight = this.model.children.find(child => child.name === 'logo004')
    logoRight.material = this.logoMaterial
    const logoCenterRight = this.model.children.find(child => child.name === 'logo005')
    logoCenterRight.material = this.logoMaterial
    const logoCenterLeft = this.model.children.find(child => child.name === 'logo006')
    logoCenterLeft.material = this.logoMaterial

    //field
    const south = this.model.children.find(child => child.name === 'south')
    south.material = this.southMaterial
    this.model.scale.set(0.4, 0.4, 0.4)
    this.scene.add(this.model)
  }

  hidePart() {
    const ctrl = document.querySelector('.south .slider')
    ctrl.addEventListener('click', () => {
      this.model.traverse(child => {
        if (child instanceof THREE.Mesh && child.visible === true) {
          child.visible = false
        } else child.visible = true
      })
    })
  }
}
